export default __webpack_public_path__ + "c72834a8b53b21c52492e4a08fd37755.jpg";